import List from '@utils/list'
const { Jurisdiction, Table } = List

import Operation from '@utils/common/operation'

import { publish, unPublish } from '@api/achievements'

async function release(this: any, row: any) {
  await this.$confirm(this.$t('performance.qualitativeFormula.release'))
  await publish(row.id)
  this.refresh()
}

async function unrelease(this: any, row: any) {
  await this.$confirm(this.$t('performance.qualitativeFormula.unrelease'))
  await unPublish(row.id)
  this.refresh()
}

const operation = new Operation('performance.qualitativeFormula')
  .add('release').show(item => item.status === '1').handle(release)
  .add('unrelease').type('info').show(item => item.status === '0').handle(unrelease)

const jurisdiction = new Jurisdiction()
  .lib('add').to('Performance.QualitativeFormula.Add')
  .lib('modify').modify('Performance.QualitativeFormula.Modify')
  .lib('delete').del('/srmQualitativeItem/deleteSrmQualitativeItemByIds', process.env.VUE_APP_PURCHASE_API)

const table = new Table('performance.qualitativeFormula')
  .add('qualitativeFormulaNo').name('qualitativeFormulaName')
  .add('status')
  .add('remarks')

export default new List()
  .url('/srmQualitativeFormula/getSrmQualitativeFormulaPageByParams', process.env.VUE_APP_PURCHASE_API)
  .jurisdiction(jurisdiction)
  .table(table)
  .operation(operation)
  .end()
